import { loadableWithFallback } from '@vision/ui/utils';
import type { TrendChart5Props } from './TrendChart5';

export const TrendChart5 = loadableWithFallback<TrendChart5Props>(() => import('./TrendChart5'));
